module["exports"] = [
  "#{Name.last_name} #{suffix}",
  "#{Name.last_name}-#{Name.last_name}",
  "#{Name.last_name}, #{Name.last_name} #{suffix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/company/name.js
 ** module id = 1076
 ** module chunks = 0
 **/